import { createContext } from "react";
import type { IConfig } from "src/utils/ConfigLoader";

const ConfigContext = createContext<IConfig | null>(null);

export default ConfigContext;
